<template lang="pug">
  .product-item

    v-card.mb-2
      v-img(:src="image.image ? image.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1")
      div
        v-btn(color="grey darken-1" text block @click="clickDelete") {{ $t('delete') }}
        //- v-col.py-2.px-0
          v-row(align="end")
            v-col.pb-2.pt-0
            v-col.py-0.pl-0(cols="5" align="end")
              v-btn(icon @click="clickDelete")
                v-icon(color="#6E6E6E") mdi-delete-outline

    .modals
      y-dialog(v-model='openDeleteDialog', max-width='290' persistent)
        v-card
          v-card-title.title {{ $t('delete_image') }}
          v-card-text
            | {{ $t('delete_image_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='grey' text @click='openDeleteDialog = false')
              | {{ $t('cancel') }}
            v-btn(color='red' text @click='startDelete')
              | {{ $t('delete') }}

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'ProductImageItem',
  props: ['productId', 'image'],
  data: () => ({
    openDeleteDialog: false
  }),
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    clickDelete () {
      this.openDeleteDialog = true
    },
    startDelete() {
      this.axios.delete(`/products/${this.productId}/images/${this.image.id}`)
        .then(() => {
          this.$emit('deleted', this.image)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    }
  }
}
</script>

<style scoped>
.count-layout {
  position: absolute;
  right: 10px;
  top: 6px;
}
.product-title {
  font-size: 16px;
  font-weight: bold;
  height: 2.8em; 
  line-height: 1.4em; 
  overflow: hidden;
}
.product-description {
  font-size: 12px;
  height: 3.3em; 
  text-overflow: ellipsis; 
  line-height: 1.1em; 
  white-space: pre-wrap;
  overflow: hidden;
}
.product-price {
  font-size: 16px;
  font-weight: bold;
}
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
</style>
